// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__nL5dJ","footer":"ReportModalFilter_footer__3dL54"};